<div class="container ktbl-container-border ktbl-container-size">
  <h3 mat-dialog-title>Schnelleinstellungen</h3>

  <mat-dialog-content>

    <!-- Windrichtungsbereich: unabhängig von der Windhäufigkeit -->
    <div class="ktbl-grid-container-columns-2">
      <mat-form-field
        appearance="fill"
        class="ktbl-input-box">

        <mat-label>Windrichtung von</mat-label>

        <mat-select
          required
          disableRipple
          [formControl]="windhaeufigkeitVonFormControl"
          (selectionChange)="onSelectWindrichtungVon()"
          panelClass="ktbl-large-select-panel">

          <mat-option
            *ngFor="let entry of windRichtungVonList"
            [value]="entry">
            {{ entry }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        appearance="fill"
        class="ktbl-input-box">

        <mat-label>Windrichtung bis</mat-label>

        <mat-select
          required
          disableRipple
          [formControl]="windhaeufigkeitBisFormControl"
          panelClass="ktbl-large-select-panel">

          <mat-option
            *ngFor="let entry of windRichtungBisList"
            [value]="entry">
            {{ entry }}
          </mat-option>
        </mat-select>

        <mat-error
          *ngIf="
            windhaeufigkeitBisFormControl.invalid
          ">
          Es muss ein neuer Wert angegeben werden, da
          Windrichtung „Von“ größer als „Bis“ ist.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="ktbl-spacer-top-bottom"></div>

    <!-- Windhäufigkeit -->
    <div class="ktbl-grid-container-full">
      <mat-checkbox
        [formControl]="windhaeufigkeitBeruecksichtigenFormControl">
        Windhäufigkeit berücksichtigen
      </mat-checkbox>
    </div>

    <div class="ktbl-spacer-top-bottom"></div>

    <ng-container
      *ngIf="
        windhaeufigkeitBeruecksichtigenFormControl.value;
        else windhaeufigkeitIgnoriert
      ">

      <div class="ktbl-grid-container-columns-2">
        <mat-form-field
          appearance="fill"
          class="ktbl-input-box">

          <mat-label>Windhäufigkeit in ‰</mat-label>

          <input
            matInput
            required
            class="ktbl-input-table-cell-left"
            [formControl]="windhaeufigkeitFormControl" />

          <mat-error
            *ngIf="windhaeufigkeitFormControl.invalid">
            {{ formControlGanzZahlLaeng2NumberWarning }}
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-template #windhaeufigkeitIgnoriert>
      <div class="ktbl-grid-container-full">
        Windhäufigkeit wird beim Übernehmen nicht berücksichtigt.
      </div>
    </ng-template>

    <div class="ktbl-spacer-top-bottom"></div>

    <!-- Gebietskategorie -->
    <div class="ktbl-grid-container-full">
      <mat-checkbox
        [formControl]="gebietskategorieBeruecksichtigenFormControl">
        Gebietskategorie berücksichtigen
      </mat-checkbox>
    </div>

    <div class="ktbl-spacer-top-bottom"></div>

    <ng-container
      *ngIf="
        gebietskategorieBeruecksichtigenFormControl.value;
        else gebietskategorieIgnoriert
      ">

      <div class="ktbl-grid-container-columns-3">
        <mat-form-field
          appearance="fill"
          class="ktbl-input-box ktbl-row2-left">

          <mat-label>Gebietskategorie</mat-label>

          <mat-select
            required
            disableRipple
            [formControl]="gebietskategorieFormControl"
            panelClass="ktbl-large-select-panel">

            <mat-option
              *ngFor="let entry of gebietskategorieList"
              [value]="entry.idGebietskategorie">
              {{ entry.gebietskategorie }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="fill"
          class="ktbl-input-box ktbl-row2-right">

          <mat-label>
            Zulässige Geruchsstundenhäufigkeit nach
            Anhang 7 TA Luft in %
          </mat-label>

          <input
            matInput
            required
            [formControl]="hgFormControl" />

          <mat-error
            *ngIf="hgFormControl.invalid">
            {{ formControlGanzZahlLaeng2OderKomma2NumberWarning }}
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <ng-template #gebietskategorieIgnoriert>
      <div class="ktbl-grid-container-full">
        Gebietskategorie und zulässige
        Geruchsstundenhäufigkeit werden beim Übernehmen
        nicht berücksichtigt.
      </div>
    </ng-template>

  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="ktbl-button-container">
      <div class="ktbl-button-container-left">
        <button
          class="ktbl-button-sekundaer ktbl-button-width-m"
          type="button"
          [mat-dialog-close]="0">
          Abbrechen
        </button>
      </div>

      <div class="ktbl-button-container-right">
        <button
          class="ktbl-button-primaer ktbl-button-width-m"
          type="button"
          [disabled]="!isFormValid()"
          [mat-dialog-close]="1">
          Übernehmen
        </button>
      </div>
    </div>
  </mat-dialog-actions>

  <div class="ktbl-spacer-top-bottom"></div>
</div>